module.exports = __webpack_public_path__ + "static/media/up-arrrows.be3ab230.png";